import { createSelector } from 'reselect';

import { State } from '../types';
import { TransferStates } from '@wetransfer/transfer/transfer-bundle/constant/transfer-states';

export const selectTransfer = (state: State): State['transfer'] =>
  state.transfer;

export const selectTransferParentID = createSelector(
  selectTransfer,
  (transfer) => transfer.parent_id
);

export const selectTransferState = createSelector(
  selectTransfer,
  (transfer: State['transfer']): TransferStates => transfer.state
);

export const selectTransferId = createSelector(
  selectTransfer,
  (transfer): string | false => transfer?.id || false
);
